/**
 * TenantContext — Standalone version for MentorWallet.
 *
 * Provides the fixed MentorWallet tenant to the component tree.
 * No DB queries, no loading states.
 */

import { createContext, useContext, type ReactNode } from 'react'
import { getTenantSync, type Tenant } from '@/lib/tenant'

interface TenantContextValue {
  tenant: Tenant
  isLoading: boolean
}

const ctx = createContext<TenantContextValue>({
  tenant: getTenantSync(),
  isLoading: false,
})

export function TenantProvider({ children }: { children: ReactNode }) {
  return (
    <ctx.Provider value={{ tenant: getTenantSync(), isLoading: false }}>
      {children}
    </ctx.Provider>
  )
}

export function useTenant() {
  return useContext(ctx)
}

export function useTenantId(): string {
  return getTenantSync().id
}
